import { render, staticRenderFns } from "./KeyInfo.vue?vue&type=template&id=2fc14bc8&scoped=true&"
import script from "./KeyInfo.vue?vue&type=script&lang=ts&"
export * from "./KeyInfo.vue?vue&type=script&lang=ts&"
import style0 from "./KeyInfo.vue?vue&type=style&index=0&id=2fc14bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc14bc8",
  null
  
)

export default component.exports